import { History, Location } from 'history';
import { accountLoginUrl, baseUrl } from '@src/app/routes';

export const redirectToLoginWithCurrentPath = (history: History): void => {
  const currentPath = (history.location as Location).pathname || baseUrl;

  const location = {
    pathname: accountLoginUrl,
    state: {
      from: { pathname: currentPath },
    },
  };

  history.push(location);
};
